import React from 'react';

const EducatorHome = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Educator Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-2">My Courses</h3>
          <p className="text-gray-600">Manage your courses</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-2">Students</h3>
          <p className="text-gray-600">View enrolled students</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-2">Analytics</h3>
          <p className="text-gray-600">Track performance</p>
        </div>
      </div>
    </div>
  );
};

export default EducatorHome;